<template>
    <div class="detail-info" :class="{ 'open-read-more': openReadMore }">
        <Provided v-if="positionProvidedTop" theme="broker" />
        <DetailInfoHeader />
        <DetailInfoGroup
            :showPropUpdate="false"
            :showPropertyMore="true"
            @refresh-parent="calcShowReadMore"
            :firstRowClass="isMobileSize ? 'single-column' : 'two-columns'"
        />
        <p
            class="read-more"
            v-if="showReadMore"
            @click="onReadMore"
            :class="{ more: !openReadMore }"
        >
            <span>{{
                openReadMore
                    ? $t('md-detail-info.readLessInfo')
                    : $t('md-detail-info.readMoreInfo')
            }}</span>
            <i
                class="iconfont icon-angle"
                :class="{ expand: openReadMore }"
            ></i>
        </p>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore } from '@/store';
import DetailInfoHeader from './detail-info-header/index.vue';
import DetailInfoGroup from '../detail-info-group.vue';
import Provided from '../provided';
import util from '@/common/util';

export default {
    emits: ['readMore'],
    i18next: {
        ns: 'md-detail-info'
    },
    components: { DetailInfoHeader, DetailInfoGroup, Provided },
    inject: ['readMore'],
    props: {
        positionProvidedTop: Boolean,
        isapp: {
            type: Boolean,
            required: true
        }
    },
    data: function() {
        return {
            agentInfo: {},
            showReadMore: false
        };
    },
    mounted() {
        this.calcShowReadMore();
    },
    methods: {
        calcShowReadMore() {
            if (util.isSSRServer) {
                return; 
            }
            this.$nextTick(() => {
                if (
                    this.$el.offsetHeight < this.$el.scrollHeight &&
                    !this.openReadMore
                ) {
                    this.showReadMore = true;
                }
                if (this.$el.offsetHeight > 640 && this.openReadMore) {
                    this.showReadMore = true;
                }
            });
        },
        onReadMore() {
            this.readMore(() => {
                if (!this.openReadMore) {
                    this.$nextTick(() => {
                        this.$el.scrollIntoView();
                    });
                }
                setTimeout(() => {
                    this.$emit('readMore');
                }, 0);
            });
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        ...mapState({
            "listingDetail": "listingDetail",
            "triggerReadMore": "triggerReadMore",
            "openReadMore": "openReadMore"
        }),
        
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        info() {
            return this.listingDetail.info;
        },
        daysOnSite() {
            return this.listingDetail.daysOnSite || 10;
        },
        showShare() {
            return (
                this.listingDetail.facebookHref ||
                this.listingDetail.twitterHref ||
                this.listingDetail.linkedinHref
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-detail-info.broker {
    .detail-info {
        overflow: hidden;
        position: relative;
        max-height: 640px;
        &.open-read-more {
            max-height: none;
            .read-more {
                position: static;
                &::before {
                    display: none;
                }
            }
        }
        &.more,
        &.show-all {
            height: auto;
        }
        @media (min-width: 1024px) {
            .read-more.more {
                width: calc(100% - 40px);
            }
        }
        .read-more {
            position: absolute;
            left: 0;
            bottom: 0;
            cursor: pointer;
            display: flex;
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            background-color: #f3f3f3;
            margin-top: 20px;
            span {
                font: 14px var(--font-normal);
                color: var(--color-theme);
                margin-right: 2px;
            }
            .iconfont {
                font-size: 22px;
                color: var(--color-theme);
                display: inline-block;
                &.expand {
                    transform: rotate(180deg);
                }
            }
            &::before {
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                height: 20px;
                background-image: linear-gradient(
                    to bottom,
                    rgba(255, 255, 255, 0),
                    #fff
                );
                width: 100%;
            }
        }
        &.show-all {
            .read-more {
                display: none;
            }
        }
        .fix-wrap {
            display: none;
        }
        h4.detail-title {
            margin-bottom: 0;
            padding-bottom: 15px;
        }

        .detail-info-group .key-info {
            p.detail-title {
                margin-top: 1.33em;
            }
            .detail-title {
                font: 16px var(--font-bold);
                color: #191919;
            }
            .info-content {
                .info-data {
                    font: 14px var(--font-normal);
                    line-height: 24px;
                    color: #505050;
                }
            }
            .content {
                h5.info-content {
                    padding: 10px 0;
                    display: flex;
                    align-items: center;
                    .info-title {
                        flex: 1;
                        margin-right: 15px;
                        max-width: 150px;
                        font: 14px var(--font-normal);
                        color: #505050;
                        white-space: normal;
                        line-height: 21px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                    .info-data {
                        font: 14px var(--font-medium);
                        color: #505050;
                        line-height: 21px;
                    }
                }
                &.two-columns {
                    .info-content {
                        width: 50%;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                        padding-top: 15px;
                        &:nth-of-type(1),
                        &:nth-of-type(2) {
                            border-top: 1px solid rgba(0, 0, 0, 0.1);
                        }
                        &:nth-child(even) {
                            margin-left: 0;
                        }
                    }
                }
                &.two-columns .info-content:nth-child(odd):last-child {
                    width: 100%;
                }

                &:not(.two-columns) {
                    h5.info-content {
                        border-top: 1px solid rgba(0, 0, 0, 0.1);
                        padding: 10px 0;
                        &:nth-last-of-type(1) {
                            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                        }
                    }
                }
            }
            @include media-600 {
                .detail-title {
                    padding-bottom: 10px;
                }
                .content {
                    &.mobile.single-column {
                        padding-top: 6px;
                        h5.info-content {
                            display: flex;
                            align-content: center;
                            border-top: none;
                            border-bottom: none;
                            padding: 0 !important;
                            color: #505050;
                            line-height: 27px;
                            .info-title {
                                width: max-content;
                                font-size: 12px;
                                font-family: var(--font-normal);
                                line-height: 24px;
                            }
                            .info-data {
                                width: calc(100% - 145px);
                                font-size: 12px;
                                font-family: var(--font-medium);
                                margin-left: 0;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }
        }
        .detail-info-group .content {
            padding-top: 0;
        }
    }
    @include media-1280 {
        .detail-info {
            max-height: 710px;
            .no-margin-top-pre-next {
                margin-top: 0;
            }
            .no-margin-top-pre-next {
                margin-top: 0;
            }
        }
        .content {
             .info-data {
                width: 60% !important;
                margin-left: 0 !important;
                padding-left: 0 !important;
             }
        }
    }

    @include media-800 {
        .detail-info {
            margin-top: 0px;
        }
    }
}
</style>
